import { SsoConfigDetail, SsoConfigSaveResponse } from "../model/ssoConfigPayload"

export interface SsoConfigListInfo {
    isConfigListFetchInProgress: boolean,
    isConfigListFetchSuccess: boolean,
    configListFetchError: string,
    configList: SsoConfigDetail[]
}

export interface SaveSsoConfigInfo {
    isSaveConfigRequestInProgress: boolean,
    isSaveConfigRequestSuccess: SsoConfigSaveResponse | null,
    saveConfigRequestError: string
}

export interface DeleteSsoConfigInfo {
    isDeleteConfigRequestInProgress: boolean,
    isDeleteConfigRequestSuccess: boolean,
    deleteConfigRequestError: string
}

const defaultConfigListInfo: SsoConfigListInfo = {
    isConfigListFetchInProgress: false,
    isConfigListFetchSuccess: false,
    configListFetchError: "",
    configList: []
}

const defaultSaveConfigInfo: SaveSsoConfigInfo = {
    isSaveConfigRequestInProgress: false,
    isSaveConfigRequestSuccess: null,
    saveConfigRequestError: ""
}

const defaultDeleteConfigInfo: DeleteSsoConfigInfo = {
    isDeleteConfigRequestInProgress: false,
    isDeleteConfigRequestSuccess: false,
    deleteConfigRequestError: ""
}

export interface SsoConfigState {
    configListDetails: SsoConfigListInfo,
    saveConfigDetails: SaveSsoConfigInfo,
    deleteConfigDetails: DeleteSsoConfigInfo
}

const defaultState: SsoConfigState = {
    configListDetails: defaultConfigListInfo,
    saveConfigDetails: defaultSaveConfigInfo,
    deleteConfigDetails: defaultDeleteConfigInfo
}

const SsoConfigReducer = (state: SsoConfigState = defaultState, action: any) => {
    switch (action.type) {
        case "SSO_CONFIG_LIST_REQUEST": {
            return {
                ...state,
                configListDetails: {
                    isConfigListFetchInProgress: true,
                    isConfigListFetchSuccess: false,
                    configListFetchError: "",
                    configList: state.configListDetails.configList
                }
            }
        }
        case "SSO_CONFIG_LIST_SUCCESS": {
            return {
                ...state,
                configListDetails: {
                    isConfigListFetchInProgress: false,
                    isConfigListFetchSuccess: true,
                    configListFetchError: "",
                    configList: action.payload || []
                }
            }
        }
        case "SSO_CONFIG_LIST_ERROR": {
            return {
                ...state,
                configListDetails: {
                    isConfigListFetchInProgress: false,
                    isConfigListFetchSuccess: false,
                    configListFetchError: action.payload,
                    configList: []
                }
            }
        }
        case "SSO_CONFIG_SAVE_REQUEST": {
            return {
                ...state,
                saveConfigDetails: {
                    isSaveConfigRequestInProgress: true,
                    isSaveConfigRequestSuccess: null,
                    saveConfigRequestError: ""
                }
            }
        }
        case "SSO_CONFIG_SAVE_SUCCESS": {
            return {
                ...state,
                saveConfigDetails: {
                    isSaveConfigRequestInProgress: false,
                    isSaveConfigRequestSuccess: action.payload,
                    saveConfigRequestError: ""
                }
            }
        }
        case "SSO_CONFIG_SAVE_ERROR": {
            return {
                ...state,
                saveConfigDetails: {
                    isSaveConfigRequestInProgress: false,
                    isSaveConfigRequestSuccess: null,
                    saveConfigRequestError: action.payload
                }
            }
        }
        case "SSO_CONFIG_DELETE_REQUEST": {
            return {
                ...state,
                deleteConfigDetails: {
                    isDeleteConfigRequestInProgress: true,
                    isDeleteConfigRequestSuccess: false,
                    deleteConfigRequestError: ""
                }
            }
        }
        case "SSO_CONFIG_DELETE_SUCCESS": {
            return {
                ...state,
                deleteConfigDetails: {
                    isDeleteConfigRequestInProgress: false,
                    isDeleteConfigRequestSuccess: true,
                    deleteConfigRequestError: ""
                }
            }
        }
        case "SSO_CONFIG_DELETE_ERROR": {
            return {
                ...state,
                deleteConfigDetails: {
                    isDeleteConfigRequestInProgress: false,
                    isDeleteConfigRequestSuccess: false,
                    deleteConfigRequestError: action.payload
                }
            }
        }
        case "SSO_CONFIG_CLOSE_MODAL": {
            return {
                ...state,
                saveConfigDetails: defaultSaveConfigInfo,
                deleteConfigDetails: defaultDeleteConfigInfo
            }
        }
        case "CLEAR_SSO_CONFIG_STORE": {
            return {
                ...defaultState
            }
        }
        default:
            return state;
    }
}

export default SsoConfigReducer
